import { template, internal } from '../../../vendor/elix.js';
import CheckableInputBase from '../checkable-input-base.js';

class TpCheckboxBase extends CheckableInputBase {
  shouldShowPressAnimation() {
    return true;
  }

  [internal.componentDidMount]() {
    if (super[internal.componentDidMount]) {
      super[internal.componentDidMount]();
    }
    this.setNativeInput();
    this[internal.ids].inner.addEventListener('change', (e) => {
      e.preventDefault();
      this.onChange();
    });
    
    if (!this.hasAttribute('tabindex')) {
      this.setAttribute('tabindex', 0);
    }
  }

  [internal.render](changed) {
    super[internal.render](changed);
    if (changed.checked) {
      this.setNativeInput();
    }
  }

  [internal.componentDidUpdate](changed) {
    super[internal.componentDidUpdate](changed);
    if (changed.checked) {
      this.dispatchEvent(new Event('change', { composed: true, bubbles: true }));
    }
  }

  onChange() {
    this.checked = !this.checked;
  }

  setNativeInput() {
    this[internal.ids].inner.checked = this.checked;
    this[internal.nativeInternals] && this[internal.nativeInternals].setFormValue(this.checked ? this.value : '');
  }

  get [internal.template]() {
    return template.concat(
      super[internal.template],
      template.html`
        <div class="checkable" id="checkable">
          <input type="checkbox" id="inner" class="checkable__input" />
          <div class="checkable__background">
            <div class="checkable__outer-border"></div>
            <div class="checkable__inner-element"></div>
          </div>
        </div>
        <style>
          .checkable__outer-border {
            border-radius: 3px;
          }
          .checkable__inner-element {
            display: inline-block;
            transform: rotate(45deg);
            height: var(--tp-checkbox-check-height);
            width: var(--tp-checkbox-check-width);
            border-bottom: var(--tp-checkbox-check-border-width) solid var(--tp-checkbox-check-borderColor);
            border-right: var(--tp-checkbox-check-border-width) solid var(--tp-checkbox-check-borderColor);
            left: var(--tp-checkbox-check-left);
            opacity: 0;
            position: relative;
            top: var(--tp-checkbox-check-top);
          }
          
          .checkable__input:checked + .checkable__background .checkable__outer-border {
            background: var(--tp-checkable-color-selected);
          }
          .checkable__input:checked + .checkable__background .checkable__inner-element {
            opacity: 1;
          }
        </style>
      `
    );
  }
}

export default TpCheckboxBase;
